<template>
  <ul class="list-inline ul-breadcrumb navbar-left">
    <template v-for="(routeObject, index) in routeRecords">
      <li class="active" v-if="isLast(index)">{{ getName(routeObject) }}</li>
      <li v-else><router-link :to="routeObject">{{ getName(routeObject) }}</router-link></li>
    </template>
  </ul>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  props: {
    list: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  computed: {
    ...mapGetters('ContractController', ['ClientContractID']),
    routeRecords: function () {
      return this.list.filter((route,index) => {
        if(index == 1) return route.meta.label= this.ClientContractID.contract_name;
        return route.name || route.meta.label
      })
    }
  },
  methods: {
    getName (item) {
      let path = item.path.split("/");
      if(path.length >= 2) {
        path[2] = this.$route.params.id;
      }
      path = path.join('/');
      item.path = path;
      return item.meta && item.meta.label ? item.meta.label : item.name || null
    },
    isLast (index) {
      return index === this.list.length - 1
    }
  }
}
</script>
